import { isBefore } from "date-fns";
import { Project } from "interfaces/front/business";

export const isNotSupportEnded = (project: Pick<Project, "support_end_at">): boolean => {
  return isBefore(new Date(), new Date(project.support_end_at));
};

export interface EndingCountdownExpression {
  data: number;
  unit: string;
}
